import { render } from "./InfoFinanciera.vue?vue&type=template&id=2ed487a8&ts=true"
import script from "./InfoFinanciera.vue?vue&type=script&lang=ts"
export * from "./InfoFinanciera.vue?vue&type=script&lang=ts"

import exportComponent from "C:\\agentcloudALProd\\_work\\12\\s\\AEL.NominaElectronica.Web\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__